"use client";
import { useState } from "react";
import { Link } from "react-router-dom";
import { DOCS_URL } from "../../tables/utils";

export default function NavBar({ activeLink }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const dashboardClass = `nav-link${
    activeLink === "dashboard" ? " active" : ""
  }`;
  const dropdownHref = (hash) => (activeLink ? `/#${hash}` : `#${hash}`);
  const blogClass = `nav-link${activeLink === "blog" ? " active" : ""}`;
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prev) => !prev);
  };
  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <div className="mobile-header">
        <Link 
          to="/" 
          className="logo" 
          onClick={closeMobileMenu} 
          style={{ 
            color: '#1a2b5f', 
            textDecoration: 'none'
          }}
        >
          <svg
            className="logo-icon"
            viewBox="0 0 48 48"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            style={{ color: '#1a2b5f' }}
          >
            <path
              className="logo-c"
              d="M34 10C28 6 18 6 12 12C6 18 6 30 12 36C18 42 28 42 34 38"
              stroke="#1a2b5f"
              strokeWidth="4"
              strokeLinecap="round"
              fill="none"
            />
            <g className="balance-line">
              <path
                className="logo-line"
                d="M14 24L34 24"
                stroke="#5BA4E6"
                strokeWidth="3"
                strokeLinecap="round"
              />
            </g>
            <circle className="logo-dot" cx="24" cy="24" r="4" fill="#5BA4E6" />
          </svg>
          <span 
            className="logo-text" 
            style={{ 
              color: '#1a2b5f', 
              display: 'inline-block'
            }}
          >
            Cutwater
          </span>
        </Link>
        <button
          className={`hamburger${isMobileMenuOpen ? " is-open" : ""}`}
          type="button"
          aria-label={isMobileMenuOpen ? "Close menu" : "Open menu"}
          aria-expanded={isMobileMenuOpen}
          aria-controls="mobile-menu"
          onClick={toggleMobileMenu}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
      <div
        id="mobile-menu"
        className={`mobile-menu${isMobileMenuOpen ? " is-open" : ""}`}
        aria-hidden={!isMobileMenuOpen}
      >
        <Link to="/dashboard" onClick={closeMobileMenu}>
          Dashboard
        </Link>
        <Link to="/blog" onClick={closeMobileMenu}>
          Blog
        </Link>
        <a
          href={DOCS_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={closeMobileMenu}
        >
          Docs
        </a>
        <a href="#" onClick={closeMobileMenu}>
          Launch App
        </a>
      </div>
      <nav>
        <div className="container">
          <div className="nav-content">
            <div className="logo-wrapper">
              <Link className="logo" to="/">
                <svg
                  className="logo-icon"
                  viewBox="0 0 48 48"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                >
                  <path
                    className="logo-c"
                    d="M34 10C28 6 18 6 12 12C6 18 6 30 12 36C18 42 28 42 34 38"
                    stroke="#1a2b5f"
                    strokeWidth="4"
                    strokeLinecap="round"
                  />
                  <g className="balance-line">
                    <path
                      className="logo-line"
                      d="M14 24L34 24"
                      stroke="#5BA4E6"
                      strokeWidth="3"
                      strokeLinecap="round"
                    />
                  </g>
                  <circle className="logo-dot" cx="24" cy="24" r="4" fill="#5BA4E6" />
                </svg>
                <span className="logo-text">Cutwater</span>
                <svg
                  className="dropdown-arrow"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path className="arrow-1" d="M6 7l6 4 6-4" />
                  <path className="arrow-2" d="M6 15l6 4 6-4" />
                </svg>
              </Link>
              <div className="nav-dropdown">
                <Link to={dropdownHref("strategy")}>Strategy</Link>
                <Link to={dropdownHref("performance")}>Performance</Link>
                <Link to={dropdownHref("process")}>How It Works</Link>
                <Link to={dropdownHref("risk")}>Risk</Link>
              </div>
            </div>
            <div className="nav-cta">
              <Link
                className={dashboardClass}
                to="/dashboard"
                aria-current={activeLink === "dashboard" ? "page" : undefined}
              >
                Dashboard
              </Link>
              <Link
                className={blogClass}
                to="/blog"
                aria-current={activeLink === "blog" ? "page" : undefined}
              >
                Blog
              </Link>
              <a
                className="btn btn-secondary"
                href={DOCS_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                Docs
              </a>
              <a className="btn btn-primary" href="#">
                Launch App
              </a>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}
